import React, { useState, useEffect, useContext } from 'react';
import { useAuth, useProtectedPage } from '../../../context/AuthContext';
import useCallApi from '../../../hooks/useCallApi';
import { SystemMessageContext } from '../../../context/SystemMessageContext';
import Loading from '../../../templates/UI/Loading/Loading';
import Dollars from '../../../templates/Dollars/Dollars';
import moment from 'moment';

export default function AffiliatePaymentEstimator(){

    document.title = 'Affiliate Payment Estimator'

    const auth = useAuth()
    useProtectedPage(auth.permissions, 'affiliate_payment_totals')
    const {showSystemMessage} = useContext(SystemMessageContext)

    // get the url parameter for mode=
    let urlParams = new URLSearchParams(window.location.search);
    let modeParam = urlParams.get('mode') ? urlParams.get('mode') : ''

    let url = `affiliates/affiliatePaymentEstimator`

    const {data, dataLoaded} = useCallApi(url, 'GET', {}, [], showSystemMessage)

    return (
        <>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Affiliate Payment Estimator</h1>
            </div>
            <div className="row">
                <div className="col-xl-6">                    
                    <div className="card mb-3">
                        <div className="card-body">                            
                            <div className="alert alert-info">
                                The amounts shown in this table only represent leads that are going to become Payable within the period {dataLoaded ? `${data.report[0] ? moment(data.report[0].start_date).format('dddd MMMM Do YYYY') : ''} - ${data.report[0] ? moment(data.report[0].end_date).format('dddd MMMM Do YYYY') : ''}` : ''} and are due to be paid out on {dataLoaded ? data.report[0] ? moment(data.report[0].payment_date).format('dddd MMMM Do YYYY') : '' : ''}.<br></br><br></br>
                                As of {moment().format('dddd MMMM Do YYYY')}, there is a total of {dataLoaded ? <span className="font-weight-bold"><Dollars value={data.total_held_payments} /></span> : ''} for affiliates who have a hold payment flag set on their account and are still active in the system.<br></br><br></br>
                                Between Sunday and Wednesday - The final payable amounts have been calculated and is reflected below.
                            </div>
                            <table className="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th>Payment date</th>                                        
                                        <th className="text-right">Balance Carryover</th>
                                        <th className="text-right">Leads From Period</th>                                        
                                        <th className="text-right">Total Payable (balance + leads)</th>
                                        <th className="text-right">Payable Held Payments ({(dataLoaded && data.report.length > 0) && data.report[0].held_payments_percentage*100}%)</th>
                                        <th className="text-right">Projection by Payment Date</th>
                                    </tr>
                                </thead>
                                { dataLoaded ?
                                    <tbody>
                                        {
                                            data.report.length > 0 ?                                                
                                                    data.report.map( item => {
                                                        return  <tr>
                                                                    <td>{item.payment_date}</td>                                                                    
                                                                    <td className="text-right"><Dollars value={item.starting_balance} /></td>
                                                                    <td className="text-right"><Dollars value={item.leads_from_this_period} /></td>                                                                    
                                                                    <td className="text-right"><Dollars value={item.payable} /></td>
                                                                    <td className="text-right"><Dollars value={item.payable_held_payments} /></td>
                                                                    <td className="text-right"><Dollars value={item.projected_by_eow} /></td>
                                                                </tr>
                                                    })                                                
                                            :
                                                
                                                <tr>
                                                    <td colSpan={6}>No results</td>                                            
                                                </tr>
                                                
                                        }                                        
                                    </tbody>
                                :
                                    <tbody>
                                        <tr>
                                            <td colSpan={6}><Loading /></td>                                            
                                        </tr>
                                    </tbody>
                                }
                                
                            </table>
                        </div>
                    </div>
                </div>
            </div>            
        </>
    )

}